import { Controller } from "@hotwired/stimulus"

// Controla a abertura e fechamento da sidebar no modo responsivo
export default class extends Controller {
  static targets = ["sidebar", "overlay"]

  connect() {
    this.isOpen = false
  }

  toggle(event) {
    if (event) event.stopPropagation() // impede clique de propagar até o body
    this.isOpen = !this.isOpen
    this.sidebarTarget.classList.toggle("-translate-x-full", !this.isOpen)
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.toggle("hidden", !this.isOpen)
    }
  }

  close() {
    if (this.isOpen) this.toggle()
  }
}
